/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const Contract = z.object({ link: z.string(), type: z.enum(['DSA', 'MSA']) })

export interface Contract extends z.TypeOf<typeof Contract> {}
